<!-- tabindex is necessary to be a valid focus target for the <ish-skip-content-link> component -->
<div #mapContainer id="store-locator-map" class="map-height" tabindex="-1"></div>
